<script lang="ts">
  export let src = './generic-logo.svg';
  export let eventName = 'Generic Poll';
</script>

<img {src} alt="Logo for {eventName}" width="288" height="288" />

<style>
  img {
    padding: 1rem;
  }
</style>
